import {type Edge, type Node} from '@xyflow/react'

import {type FlowEntity, type FlowSetup, type TerminalNode} from '../types'

const DEFAULT_NODE_X = 0
const DEFAULT_NODE_Y = 0

export const mapFlowToNodes = (
  setup: FlowSetup,
  entities: FlowEntity[],
  terminalNode: TerminalNode,
  nodeType: string
): Node[] => {
  const nodes: Node[] = entities.map((entity) => {
    const position = setup.positions.find((pos) => pos.nodeId === entity.id)
    return {
      id: entity.id,
      type: nodeType,
      position: {x: position?.x ?? DEFAULT_NODE_X, y: position?.y ?? DEFAULT_NODE_Y},
      data: {label: entity.label}
    }
  })

  const terminalPosition = setup.positions.find((pos) => pos.nodeId === terminalNode.id)!
  nodes.push({
    id: terminalNode.id,
    type: nodeType,
    position: {x: terminalPosition.x, y: terminalPosition.y},
    data: {label: terminalNode.label}
  })

  return nodes
}

export const mapFlowToEdges = (setup: FlowSetup): Edge[] => {
  return setup.links.map((link) => ({
    id: `${link.sourceNodeId}->${link.targetNodeId}`,
    source: link.sourceNodeId,
    target: link.targetNodeId
  }))
}
